"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_1 = require("react");
const react_stripe_js_1 = require("@stripe/react-stripe-js");
const StripePromiseProvider_1 = require("../StripePromiseProvider");
const Loader_1 = require("../../../atoms/Loader");
const StripeSetupSecretProvider_1 = require("./StripeSetupSecretProvider");
const options = {
    paymentMethodOrder: ["card"],
    wallets: {
        applePay: "never",
        googlePay: "never"
    },
    layout: "accordion",
    terms: {
        card: "never"
    },
    fields: {
        billingDetails: {
            address: {
                country: "never"
            }
        }
    }
};
const appearance = {
    theme: "flat",
    labels: "floating",
    variables: {
        colorPrimary: "#000000",
        colorText: "#000000",
        colorDanger: "#FF0000"
    },
    rules: {
        ".Input": {
            padding: "10px 12px",
            boxShadow: ""
        },
        ".Input:focus": {
            boxShadow: "none",
            border: "none"
        },
        ".Input:focus-visible": {
            boxShadow: "none",
            border: "none"
        },
        ".Input--invalid": {
            color: "#FF0000"
        }
    }
};
const CheckoutForm = ({ setStripe, setElements, errorText }) => {
    const stripe = (0, react_stripe_js_1.useStripe)();
    const elements = (0, react_stripe_js_1.useElements)();
    const [loaded, setLoaded] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (stripe)
            setStripe(stripe);
        if (elements)
            setElements(elements);
    }, [stripe, elements]);
    return (React.createElement("div", { style: { display: "flex", justifyContent: "center" } },
        !loaded && (React.createElement("div", { style: { display: "flex", justifyContent: "center", padding: 20 } },
            React.createElement(Loader_1.Loader, { size: "md" }))),
        React.createElement("div", { style: { maxWidth: 500, flex: 1, display: loaded ? undefined : "none" } },
            React.createElement(react_stripe_js_1.PaymentElement, { id: "payment-element", onReady: () => setLoaded(true), options: options }),
            React.createElement("div", { style: { padding: 20, color: "red", height: 60 } }, errorText !== null && errorText !== void 0 ? errorText : ""))));
};
exports.default = ({ clientSecret }) => {
    //use the stripe platform account for storing customer payment methods
    const { setupIntentSecret } = (0, StripeSetupSecretProvider_1.useStripeSetupSecret)();
    const { StripePlatform } = (0, StripePromiseProvider_1.useStripePromise)();
    const [stripe, setStripe] = (0, react_1.useState)(null);
    const [elements, setElements] = (0, react_1.useState)(null);
    const [errorText, setErrorText] = (0, react_1.useState)("");
    const confirmSetup = async () => {
        if (!stripe || !elements)
            return;
        setErrorText("");
        const result = await stripe.confirmSetup({
            elements,
            redirect: "if_required",
            confirmParams: {
                payment_method_data: {
                    allow_redisplay: "always",
                    billing_details: {
                        address: {
                            country: "AU" // Country
                        }
                    }
                }
            }
        });
        if (result.error) {
            setErrorText(result.error.message);
        }
        return result;
    };
    return {
        checkoutComponent: (React.createElement(React.Fragment, null, setupIntentSecret ? (React.createElement(react_stripe_js_1.Elements, { stripe: StripePlatform !== null && StripePlatform !== void 0 ? StripePlatform : null, options: {
                loader: "never",
                appearance: appearance,
                clientSecret: setupIntentSecret
            } },
            React.createElement(CheckoutForm, { errorText: errorText, setStripe: setStripe, setElements: setElements }))) : (React.createElement("div", { style: { display: "flex", justifyContent: "center", padding: 20 } },
            React.createElement(Loader_1.Loader, { size: "md" }))))),
        confirmSetup
    };
};
//# sourceMappingURL=useStripeSetupIntent.js.map